import { useEffect, useState } from "react";
import { SideModal } from "shared";
import { UserType } from "types/UsersTypes";
import { InvoiceTable, SharesTable, SuccessorTable } from "./components";
import "./UserInfoModal.scss";

interface UserInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: UserType | null;
  setEditPersonalData: (user: UserType) => void;
}

interface TabType {
  tab: "data" | "payment" | "shares" | "successor";
}

const UserInfoModal: React.FC<UserInfoModalProps> = ({
  isOpen,
  onClose,
  user,
  setEditPersonalData,
}) => {
  const [tab, setTab] = useState<TabType["tab"]>("data");

  useEffect(() => {
    setTab("data");
  }, [user]);

  return (
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Szczegółowe Informacje"
      subtitle={user?.name}
    >
      <>
        <div className="side-modal__options side-modal__options--user">
          <span
            className={`side-modal__option ${
              tab === "data" ? "side-modal__option--active" : ""
            }`}
            onClick={() => setTab("data")}
          >
            Dane użytkownika
          </span>
          <span
            className={`side-modal__option ${
              tab === "shares" ? "side-modal__option--active" : ""
            }`}
            onClick={() => setTab("shares")}
          >
            Lista udziałów
          </span>
          <span
            className={`side-modal__option ${
              tab === "successor" ? "side-modal__option--active" : ""
            }`}
            onClick={() => setTab("successor")}
          >
            Sukcesja
          </span>
        </div>
        {tab === "data" && (
          <InvoiceTable user={user} setEditPersonalData={setEditPersonalData} />
        )}
        {tab === "shares" && <SharesTable user={user} />}
        {tab === "successor" && <SuccessorTable user={user} />}
      </>
    </SideModal>
  );
};

export default UserInfoModal;
